import { AUTH, CONFIGURACION_PERFIL } from '../actions/types';

import setAuthToken from '../utils/setAuthToken';

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: false,
    usuario: {},
    empresa: {},
    membresia_actual: {}, 
    codigo: null
}

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case AUTH.LOGIN:
        case AUTH.REGISTER:
            localStorage.setItem('token', payload.token); 
            setAuthToken(localStorage.token);

            return {
                ...state, 
                ...payload,
                isAuthenticated: true
            };

        case AUTH.LOGIN_ERROR:
        case AUTH.REGISTER_ERROR:
        case AUTH.OBTENER_USUARIO_ERROR: 
        case AUTH.LOGOUT: 
            localStorage.removeItem('token');
            
            return {
                ...state,
                token: null,
                isAuthenticated: false
            };

        case AUTH.OBTENER_USUARIO:
            return {
                ...state,
                isAuthenticated: true,
                usuario: payload.usuario, 
                empresa: payload.empresa, 
                membresia_actual: payload.membresia_actual
            };

        case AUTH.RECUPERAR_USUARIO:
            return {
                ...state,
                codigo: payload,
            };

        case AUTH.RESTABLECER_USUARIO:
            return {
                ...state, payload
            };

        case AUTH.MEMBRESIA_USUARIO:
            return {
                ...state, 
                membresia_actual: payload
            };

        case CONFIGURACION_PERFIL.EDITAR_PERSONAL:
            return {
                ...state,
                usuario: payload
            };

        case CONFIGURACION_PERFIL.EDITAR_EMPRESARIAL:
            return {
                ...state,
                empresa: payload
            };
        default:
            return state;
    }
}